@if (navigationMode(); as mode) {
  <div class="neighbor-widget">
    @if (mode.parent) {
      <div
        class="neighbor-widget-button"
        [class.no-separator]="hideParentSeparatorDelayed()"
        animate.enter="neighbor-enter"
        animate.leave="neighbor-leave"
      >
        <button
          alg-button
          type="button"
          icon="ph-bold ph-arrow-elbow-left-up"
          [showCaption]="showBackCaptionDelayed()"
          [withAnimation]="true"
          class="neighbor-nav"
          (click)="parent.emit()"
          i18n
        >Back</button>
      </div>
    }
    @if (showPrevNextNav()) {
      <div
        class="neighbor-widget-prev-next"
        animate.enter="neighbor-prev-next-enter"
        animate.leave="neighbor-prev-next-leave"
        (animationend)="onPrevNextPanelAnimationEnd($event)"
      >
        <div class="neighbor-widget-button" [class.no-separator]="mode.right">
          <button
            alg-button-icon
            type="button"
            icon="ph-bold ph-caret-left"
            class="size-s no-bg nav-arrow"
            (click)="left.emit()"
            [disabled]="!mode.left"
          ></button>
        </div>
        <div class="neighbor-widget-button">
          <button
            alg-button
            type="button"
            icon="ph-bold ph-caret-right"
            [showCaption]="mode.right"
            [withAnimation]="true"
            class="neighbor-nav"
            data-testid="nav-to-next"
            (click)="right.emit()"
            [disabled]="!mode.right"
            i18n
          >Next</button>
        </div>
      </div>
    }
  </div>
}
